/* eslint-disable no-param-reassign */
import angular from 'angular';
import debounce from 'lodash/debounce';
import uniqBy from 'lodash/uniqBy';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  user: state.user.user,
  isAdminUser: state.auth.isAdminUser,
});

angular
  .module('myConsultApp')
  .controller('authorizedUserDetailController', ($ngRedux, $scope, $rootScope, $timeout, $http, ENV) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.authorizedUserDirection = null;
      $scope.authorizedUserDetail = null;
      $scope.authorizedUserReferecedUser = null;
      $scope.authorizedUser = null;
    };

    $scope.close = () => {
      $rootScope.clearAdminAuthorizedUser();
      $scope.clearAuthorizedUserDetail();
      $rootScope.closeComponent();
    };

    $scope.generatebeforeRoute = () => {
      return `${$rootScope.routes.user}/${$rootScope.userId}/authorized-user-detail/${$rootScope.adminAuthorizedUserId}`;
    };

    $scope.generatecloseRoute = () => {
      return $rootScope.previousRoute || `${$rootScope.routes.user}/${$rootScope.userId}`;
    };


    $scope.clearAuthorizedUserDetail = () => {
      $scope.isAuthorizedUserActionMenu = false;
      $scope.authorizedUserDetailTable = null;
      $scope.authorizedUserDirection = null;
      $scope.authorizedUserDetail = null;
      $scope.authorizedUserReferecedUser = null;
      $scope.authorizedUser = null;
    };

    $scope.clearAuthorizedUserDetail();

    $scope.getAuthorizedUserRecordInformation = () => {
      if($rootScope.adminAuthorizedUser.shared_user.id == $rootScope.userId){
        $scope.authorizedUserDirection = 'Shared Privileges to';
        $scope.authorizedUserDetail = $rootScope.adminAuthorizedUser.authorized_user.first_name ? $rootScope.adminAuthorizedUser.authorized_user.first_name + ' ' + $rootScope.adminAuthorizedUser.authorized_user.last_name: $rootScope.adminAuthorizedUser.authorized_user.contact_information.email;
        $scope.authorizedUserReferecedUser = $rootScope.adminAuthorizedUser.authorized_user;
        $scope.authorizedUser = $rootScope.adminAuthorizedUser;
      } else if ($rootScope.adminAuthorizedUser.authorized_user.id == $rootScope.userId){
        $scope.authorizedUserDirection = 'Received Privileges from';
        $scope.authorizedUserDetail = $rootScope.adminAuthorizedUser.shared_user.first_name ? $rootScope.adminAuthorizedUser.shared_user.first_name + ' ' + $rootScope.adminAuthorizedUser.shared_user.last_name: $rootScope.adminAuthorizedUser.shared_user.contact_information.email;
        $scope.authorizedUserReferecedUser = $rootScope.adminAuthorizedUser.shared_user;
        $scope.authorizedUser = $rootScope.adminAuthorizedUser;
      }
    }

    $scope.setTable = () => {
      $scope.getAuthorizedUserRecordInformation();
      $scope.authorizedUserDetailTable = {
        name: `History of ${$scope.authorizedUserDirection} ${$scope.authorizedUserDetail}`,
        options: {
          endpoint: `/2.0/users/${$rootScope.userId}/authorized-users/${$rootScope.adminAuthorizedUser.id}/history/`,
          endpoint_data_key: 'histories',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'standard',
          scale_up: true,
          search_key: null,
          id_prefix: 'histories',
          default_parameters: {},
        },
        actions: [],
        columns: [
          {
            name: 'Created Date',
            options: {
              content: '{{ record.created }}',
              class: '',
            },
          },
          {
            name: 'Updated Date',
            options: {
              content: '{{ record.updated }}',
              class: '',
            },
          },
          {
            name: 'Status',
            options: {
              content: '<span style="text-transform:capitalize;">{{ record.status }}</span>' +
              '<br ng-if="record.status == \'invited\'"/><span ng-if="record.status == \'invited\'">Sent To: {{ authorizedUser.invited_email }}</span>',
              class: '',
            },
          },
          {
            name: 'Acting User',
            options: {
              content: '{{ record.acting_user.first_name }} {{ record.acting_user.last_name }}<br />{{ record.acting_user.contact_information.email }}',
              class: 'td-user',
            },
          },
        ],
        filters: [
          {
            name: 'Status',
            type: 'multiple_choice',
            options: {
              choices: {
                Invited: { state: true, value: 'invited', order: 0 },
                Accepted: { state: true, value: 'accepted', order: 1 },
                Declined: { state: true, value: 'declined', order: 2 },
                Cancelled: { state: true, value: 'cancelled', order: 3 },
                Removed: { state: true, value: 'removed', order: 4 },
                Blocked: { state: true, value: 'blocked', order: 5 },
                Unblocked: { state: true, value: 'unblocked', order: 5 },
              },
              class: 'activity-type-filter above-divider',
              query_string_parameter: 'status',
              select_all: true,
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Created Timeframe',
            type: 'single_choice',
            options: {
              choices: {
                'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
                'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
                'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
                All: { type: 'standard', state: true, value: 'all', order: 3 },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: true,
                  order: 4,
                  error: false,
                },
              },
              class: 'timeframe-filter above-divider',
              query_string_parameter: 'created',
            },
          },
          {
            name: 'Updated Timeframe',
            type: 'single_choice',
            options: {
              choices: {
                'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
                'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
                'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
                All: { type: 'standard', state: true, value: 'all', order: 3 },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: true,
                  order: 4,
                  error: false,
                },
              },
              class: 'timeframe-filter above-divider',
              query_string_parameter: 'updated',
            },
          },
        ],
        sort_options: {
          updated: {
            state: true,
            value: '-1',
            title: 'Updated',
            order: 0,
          },
          created: {
            state: false,
            value: '1',
            title: 'Created',
            order: 1,
          },
        },
      };
    };

    const adminAuthorizedUserListener = $rootScope.$watch('adminAuthorizedUser', () => {
      if ($rootScope.adminAuthorizedUser) {
        $scope.setTable();
      } else {
        $scope.clearAuthorizedUserDetail();
      }
    });

    $scope.showAuthorizedUserActionMenu = () => {
      $scope.isAuthorizedUserActionMenu = !$scope.isAuthorizedUserActionMenu;
    };

    $scope.onBlockUnblockAuthorizedUser = () => {
      var data = {
        'users': {
          'blocked': $scope.authorizedUser.blocked ? false : true
        }
      };
      $scope.blockUnblockAuthorizedUser($http, ENV, $rootScope.userId, $rootScope.adminAuthorizedUser.id, data).then((res) => {
        $scope.$apply(() => {
          $rootScope.adminAuthorizedUser = res;
          $rootScope.adminCurrentAuthorizedUser = angular.copy($rootScope.adminAuthorizedUser);
          $rootScope.getAuthorizedUserDetail();
          $rootScope.getData();
          $scope.getUser($http, ENV, $rootScope.userId);
        });
      });
    }

    $scope.requestCancelRemoveAuthorizedUser = () => {
      $scope.cancelRemoveAuthorizedUser($http, ENV, $rootScope.userId, $rootScope.adminAuthorizedUser.id).then((res) => {
        $scope.$apply(() => {
          $rootScope.adminAuthorizedUser = res;
          $rootScope.adminCurrentAuthorizedUser = angular.copy($rootScope.adminAuthorizedUser);
          $rootScope.getAuthorizedUserDetail();
          $rootScope.getData();
          $scope.getUser($http, ENV, $rootScope.userId);
        });
      });
    }

    $scope.onCancelRemoveAuthorizedUser = () => {
      $rootScope.showErrorModal = true;
      $rootScope.errorModalOptions = {
        heading: $scope.authorizedUser.status == 'invited' ? 'Cancel Invitation?' : 'Remove Authorized User?',
        message: $scope.authorizedUser.status == 'invited' ? `Are you sure you wish to cancel this invitation?  This action cannot be undone.` : `Are you sure you wish to remove this authorized user?  This action cannot be undone.`,
        buttons: [
          {
            label: $scope.authorizedUser.status == 'invited' ? 'Cancel Invitation' : 'Remove Authorized User',
            href: '#',
            clickFn: () => {
              $scope.requestCancelRemoveAuthorizedUser();
              $rootScope.showErrorModal = false;
            },
          },
          {
            label: 'Go Back',
            href: '#',
            clickFn: () => {
              $rootScope.showErrorModal = false;
            },
          },
        ],
      };
    }

    $(document).on('click', (event) => {
      const settingEle = $('.header-actions');

      if (settingEle !== event.target && !settingEle.has(event.target).length) {
        $scope.$apply(() => {
          $scope.isAuthorizedUserActionMenu = false;
        });
      }
    });

    $scope.init();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      adminAuthorizedUserListener();
      $scope.clearAuthorizedUserDetail();
      if (!$rootScope.isUserPage) {
        $rootScope.userId = null;
      }
    });
  })
  .directive('authorizedUserDetail', () => {
    return {
      templateUrl: 'templates/v2/authorized-user-detail.html',
    };
  });
